import { breakpoints } from "../helpers/breakpoints";

export const footer = () => {
  /* Handle sticky footer height */
  const stickyFooterHeight = () => {
    const footer = document.querySelector<HTMLElement>("footer");
    const footerMaxHeight = 811;
    const screenHeight = window.innerHeight;

    /* Check footer exists */
    if (!footer) {
      return;
    }

    /* On mobile, the footer is not sticky. Remove any height styles and return */
    if (window.innerWidth < breakpoints.screen1024) {
      footer.removeAttribute("style");
      return;
    }

    /* Footer has a max height of 811. If screen size is smaller, set footer to screen size
    This is to avoid a spacing issue on smaller desktop screens where the top of the footer is getting cut off */
    if (screenHeight < footerMaxHeight) {
      footer!.style.height = screenHeight + "px";
    } else {
      footer!.style.height = footerMaxHeight + "px";
    }
  };

  /* Run function on load and resize */
  ["load", "resize"].forEach((event) =>
    window.addEventListener(event, () => {
      stickyFooterHeight();
    })
  );
};
